import { createSelector } from "reselect";

const customTablesState = (state) => state.customTables;

export const selectIsLoading = createSelector(customTablesState, (state) => state.all.loading);
export const selectError = createSelector(customTablesState, (state) => state.all.error);
export const selectAllCustomTables = createSelector(customTablesState, (state) => state.all.items);
